import React, { useState, useEffect } from "react";
import RedocParameterLabel from "../redocParamersLabel/redocParameterLabel";
import ClientIdSelect from "../../../clientIdSelect/clientIdSelect";
import "./redocParametersClientId.css";
import * as actions from "../../../../actions";
import { connect } from "react-redux";
import { parseApplications } from "../../../../constants/parse/application";
import { parseApiProducts } from "../../../../constants/parse/product";
import ModalContainer from "../../../modalContainer/modalContainer";

import StatusMessage from "../../../statusMessage/statusMessage";

function RedocParametersClientId(props) {
  const {
    documentationId,
    applications,
    errors,
    values,
    parameters,
    products,
    productUuid,
    loading,
    isLoggedIn,
    subscribeApiProductToApplication,
    unsubscribeFromApiProduct,
    subscribeErrorMessage,
    fetchApplicationsByOrganization,
    clearSubscribeErrorMessage,
  } = props;
  const [clientIdSuggestions, setClientIdSuggestions] = useState([]);
  const [clientIdModalOpen, setClientIdModalOpen] = useState(false);
  const [query, setQuery] = useState("");
  const [showProductsModal, setShowProductsModal] = useState(false);
  const [selectedAppForSubscribe, setSelectedAppForSubscribe] =
    useState(undefined);
  const [selectedAppType, setSelectedAppType] = useState(false);

  // Set Ordering of applications by the documentation API related product subscriptions
  // order: 0 -> The APP HAS MANY SUBSCRIPTIONS TO PRODUCT with the current DOCUMENTATION included
  // order: 1 -> The APP HAS MANY SUBSCRIPTIONS TO PRODUCT with the current DOCUMENTATION NOT included
  // order: 2 -> The APP HAS NOT SUBSCRIPTIONS TO PRODUCT

  const filteredApps = (applications) => {
    if (!applications || !Array.isArray(applications)) {
      return [];
    }

    // Use the productUuid passed from the swagger page
    const currentProductId = productUuid;

    console.log("Current product UUID from swagger page:", currentProductId);

    return applications
      .map((app) => {
        // Check both subscriptions and products
        const { subscriptions = [], products: appProducts = [] } = app;

        // Check if app is subscribed to current documentation's product
        let order = 2; // Default: not subscribed

        // Check subscriptions array (where subscription.uuid is the product ID)
        if (subscriptions.length > 0 && currentProductId) {
          const hasMatchingSubscription = subscriptions.find((subscription) => {
            const productId = subscription.uuid || subscription.id;
            console.log(
              `Checking app ${app.title} subscription: ${productId} against current ${currentProductId}`
            );
            return productId === currentProductId;
          });

          if (hasMatchingSubscription) {
            order = 0; // Subscribed to this product
          }
        }

        // Also check products array if no match found in subscriptions
        if (order === 2 && appProducts.length > 0 && currentProductId) {
          const hasMatchingProduct = appProducts.find((product) => {
            const productId = product.id || product.uuid;
            console.log(
              `Checking app ${app.title} product: ${productId} against current ${currentProductId}`
            );
            return productId === currentProductId;
          });

          if (hasMatchingProduct) {
            order = 0; // Has this product
          }
        }

        console.log(
          `App ${app.title}: order=${order}, subscriptions=${subscriptions.length}, products=${appProducts.length}`
        );
        return { ...app, order };
      })
      .sort((a, b) => a.order - b.order)
      .filter(
        (app) =>
          app.title && app.title.toLowerCase().includes(query.toLowerCase())
      );
  };
  useEffect(() => {
    console.log(
      "RedocParametersClientId - applications from props:",
      applications
    );
    const filtered = filteredApps(applications);
    console.log("RedocParametersClientId - filtered apps:", filtered);
    setClientIdSuggestions(filtered);
  }, [query, applications, productUuid]);

  // Fetch applications when component mounts
  useEffect(() => {
    if (isLoggedIn && fetchApplicationsByOrganization) {
      console.log(
        "RedocParametersClientId - Fetching applications by organization"
      );
      fetchApplicationsByOrganization();
    }
  }, [isLoggedIn]);

  const onAppSelect = (type, uuid) => {
    setSelectedAppForSubscribe(uuid);
    setSelectedAppType(type);

    // Preferred: the product of the documentation page we are on.
    if (productUuid) {
      handleSubscribe(type, productUuid, uuid);
      return;
    }

    // Fallback (live-portal behaviour): products related to this documentation.
    const relatedProducts = (products || []).filter(
      (product) => product.apis && product.apis.length > 0
    );
    if (relatedProducts.length === 0) {
      console.warn("Select Client: no product to subscribe to");
      return;
    }
    if (relatedProducts.length > 1 && type) {
      setShowProductsModal(true);
      return;
    }
    const app = clientIdSuggestions.find((a) => a.uuid === uuid);
    const subscribedProduct =
      relatedProducts.length > 1 && app
        ? relatedProducts.find((product) =>
            (app.subscriptionIds || []).includes(product.uuid)
          )
        : null;
    handleSubscribe(type, (subscribedProduct || relatedProducts[0]).uuid, uuid);
  };

  const handleSubscribe = (type, apiProductUuid, uuid) => {
    // Clear any existing error message when performing new action
    if (clearSubscribeErrorMessage) {
      clearSubscribeErrorMessage();
    }
    const actionToPerform = type
      ? subscribeApiProductToApplication
      : unsubscribeFromApiProduct;
    return actionToPerform({ apiProductUuid, planUuid: uuid });
  };

  const onProductSelect = (apiProductUuid) => {
    // Clear any existing error message when selecting a product
    if (clearSubscribeErrorMessage) {
      clearSubscribeErrorMessage();
    }
    handleSubscribe(selectedAppType, apiProductUuid, selectedAppForSubscribe);
    setShowProductsModal(false);
  };

  if (!(parameters && parameters[0])) return null;
  const param = parameters[0];

  const error =
    errors &&
    errors.length > 0 &&
    errors.filter((error) => error.name === param.name).length > 0;
  const id = param.in + "-" + param.name;

  return (
    <tr key={id}>
      <RedocParameterLabel param={param} id={id} />
      <td>
        <div className="redoc-param-clientId">
          <input
            type="text"
            value={values && values[param.name] ? values[param.name] : ""}
            className={error ? "has-error" : null}
            name={param.name}
            placeholder={param.name}
            required={param.required}
            onChange={
              props.onChange ? (event) => props.onChange(event, param) : null
            }
          />

          <button
            onClick={(evt) => {
              evt.preventDefault();
              setClientIdModalOpen(true);
            }}
          >
            Select...
          </button>
          <ClientIdSelect
            onClientIdSelected={(clientId) => {
              if (props.onChange) {
                props.onChange(
                  {
                    target: {
                      value: clientId,
                    },
                  },
                  param
                );
              }
            }}
            onSearch={(event) => setQuery(event.target.value)}
            modalOpen={clientIdModalOpen}
            handleModalClose={() => setClientIdModalOpen(false)}
            applications={clientIdSuggestions}
            loading={loading}
            query={query}
            isLoggedIn={isLoggedIn}
            onAppSelectHandler={onAppSelect}
            selectedAppForSubscribe={selectedAppForSubscribe}
            subscribeApiProductToApplication={subscribeApiProductToApplication}
            unsubscribeFromApiProduct={unsubscribeFromApiProduct}
            apiProductId={
              products && products.length > 0 ? products[0].uuid : null
            }
          />

          <ModalContainer
            isOpen={showProductsModal}
            contentLabel="Select Product Modal"
            title="Select Product"
            className="product-select-popup-modal"
            closeModal={() => setShowProductsModal(false)}
          >
            <p>
              Current documentation is related with multiple products. Please
              select one in order to subscribe your app.
            </p>
            <div className="product-select-popup-modal-container">
              {products &&
                products
                  .filter((r) => r.apis.length > 0)
                  .map((p) => {
                    return (
                      <div
                        key={p.uuid}
                        onClick={() => onProductSelect(p.uuid)}
                        className="product-select-popu-modal-item"
                      >
                        <img
                          style={{ width: "50px", height: "50px" }}
                          src={p.image && p.image.url}
                          alt=""
                        />

                        <div className="product-select-popup-modal-title">
                          {p.title} {p.version}
                        </div>
                      </div>
                    );
                  })}
            </div>
            <div style={{ marginTop: 20 }}>
              {subscribeErrorMessage && (
                <StatusMessage modifiers={[StatusMessage.ERROR]}>
                  {subscribeErrorMessage}
                </StatusMessage>
              )}
            </div>
          </ModalContainer>
        </div>
      </td>
    </tr>
  );
}

const mapStateToProps = (state) => {
  // Helper to safely access properties whether they're plain objects or Immutable
  const getValue = (obj, key) => {
    if (!obj) return undefined;
    // If obj has get method (Immutable), use it
    if (typeof obj.get === "function") {
      return obj.get(key);
    }
    // Otherwise, access plain object property
    return obj[key];
  };

  return {
    applications: parseApplications(
      getValue(state.application, "applicationsById")
    ),
    products: parseApiProducts(
      getValue(state.apiProduct, "apiProductsById"),
      state.apiDocumentation
    ),
    loading: getValue(state.application, "loading"),
    subscribeErrorMessage: getValue(state.apiProduct, "subscribeErrorMessage"),
    isLoggedIn: state.applicationUser?.isLoggedIn,
  };
};

const mapDispatchToProps = (dispatch) => ({
  subscribeApiProductToApplication: (payload) => {
    dispatch(actions.subscribeApiProductToApplication(payload));
  },
  unsubscribeFromApiProduct: (payload) => {
    dispatch(actions.unsubscribeFromApiProduct(payload));
  },
  clearSubscribeErrorMessage: () => {
    dispatch(actions.clearSubscribeErrorMessage());
  },
  fetchApplicationsByOrganization: () => {
    dispatch(actions.fetchApplicationsByOrganization());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RedocParametersClientId);
